/* CsakCsajok – cikk interaktív kiegészítők (ccx-*): megjelenés görgetésre, számlálók,
   orgazmustérkép-szűrő + „olvastad” jelölés, termékpolc-pöttyök, tévhit-kártyák.
   Párja: assets/cc-article-fx.css. JS nélkül minden tartalom látható marad. */
(() => {
  'use strict';
  if (window.__ccFx) return;
  window.__ccFx = true;

  const root = document.querySelector('.cc-article-ui');
  if (!root || !root.querySelector('[class*="ccx-"]')) return;

  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasIO = 'IntersectionObserver' in window;
  const buzz = (ms) => { try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) {} };
  document.documentElement.classList.add('ccu-fx');

  /* ---------- számlálók (magyar tizedesvesszővel) ---------- */
  const fmt = (v, d) => v.toFixed(d).replace('.', ',') + '%';
  const nums = $$('[data-ccx-to]');
  const countUp = (scope) => {
    scope.querySelectorAll('[data-ccx-to]').forEach((b) => {
      const to = parseFloat(b.dataset.ccxTo);
      const d = to % 1 ? 1 : 0;
      if (reduce || !isFinite(to)) { b.textContent = fmt(to, d); return; }
      const dur = 1200, t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        b.textContent = fmt(to * (1 - Math.pow(1 - p, 3)), d);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  };

  /* ---------- megjelenés görgetésre ---------- */
  const targets = $$('.ccx-map, :scope > h3.ccx-h, .ccx-bar, .ccx-stat, .ccx-fig');
  $$('.ccx-map__grid li').forEach((li, i) => li.style.setProperty('--i', i));
  const show = (el) => {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    if (el.matches('.ccx-bar, .ccx-stat')) countUp(el);
  };
  if (hasIO && !reduce) {
    nums.forEach((b) => { if (!b.closest('.is-in')) b.textContent = fmt(0, parseFloat(b.dataset.ccxTo) % 1 ? 1 : 0); });
    const io = new IntersectionObserver((es) => {
      es.forEach((en) => { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((el) => io.observe(el));
  } else {
    targets.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- orgazmustérkép ---------- */
  $$('[data-ccx-map]').forEach((map) => {
    const chips = $$('[data-ccx-f]', map);
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const f = chip.dataset.ccxF;
      map.dataset.f = f;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
    }));
    map.addEventListener('click', (e) => {
      const a = e.target.closest('.ccx-tile');
      if (!a) return;
      const id = decodeURIComponent((a.getAttribute('href') || '').slice(1));
      const el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      try { history.replaceState(null, '', '#' + id); } catch (err) {}
    });
    if (!hasIO) return;
    const tiles = new Map($$('.ccx-tile', map).map((t) => [decodeURIComponent(t.getAttribute('href').slice(1)), t]));
    const seen = new IntersectionObserver((es) => {
      es.forEach((en) => {
        if (!en.isIntersecting) return;
        const t = tiles.get(en.target.id);
        if (t) { t.classList.add('is-seen'); seen.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -55% 0px' });
    tiles.forEach((t, id) => { const h = document.getElementById(id); if (h) seen.observe(h); });
  });

  /* ---------- termékpolc: lapozó-pöttyök mobilon ---------- */
  $$('.ccx-shelf__row').forEach((row) => {
    const cards = Array.from(row.children).filter((c) => c.matches('.ccp'));
    if (cards.length < 2) return;
    const dots = document.createElement('div');
    dots.className = 'ccx-shelf__dots';
    dots.setAttribute('aria-hidden', 'true');
    dots.innerHTML = cards.map((_, i) => `<span${i ? '' : ' class="is-on"'}></span>`).join('');
    row.after(dots);
    let tick = false;
    row.addEventListener('scroll', () => {
      if (tick) return;
      tick = true;
      requestAnimationFrame(() => {
        tick = false;
        const max = row.scrollWidth - row.clientWidth;
        const i = max > 0 ? Math.round((row.scrollLeft / max) * (cards.length - 1)) : 0;
        Array.from(dots.children).forEach((d, k) => d.classList.toggle('is-on', k === i));
      });
    }, { passive: true });
  });

  /* ---------- tévhit-kártyák ---------- */
  $$('.ccx-myths').forEach((box) => {
    const cards = $$('.ccx-card', box);
    if (!cards.length) return;
    const lead = box.querySelector('.ccx-myths__lead');
    const badge = document.createElement('span');
    badge.className = 'ccx-myths__count';
    badge.setAttribute('aria-live', 'polite');
    if (lead) lead.appendChild(badge);
    const done = new Set();
    const upd = () => {
      const n = done.size, all = cards.length;
      badge.textContent = n === all ? `Mind a ${all} lebukott. Szép munka!` : `Leleplezve: ${n}/${all}`;
      badge.classList.toggle('is-done', n === all);
    };
    upd();
    cards.forEach((card, i) => card.addEventListener('click', () => {
      const on = card.getAttribute('aria-pressed') !== 'true';
      card.setAttribute('aria-pressed', String(on));
      if (on) { done.add(i); buzz(8); }
      upd();
    }));
  });
})();
